var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('div',[_c('p',{staticClass:"course-list-info-label is-size-8 has-text-weight-bold has-text-centered",style:({
      color: _vm.label.color,
      backgroundColor: _vm.label.bgcolor
    })},[_vm._v(" "+_vm._s(_vm.label.name)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }